import React from "react";
import ReactDom from "react-dom";

const ModalClickNotification = ({ notifications, openNotification }) => {
  return ReactDom.createPortal(
    <ul
      id="dropdownMenuNotification"
      className={`${
        openNotification ? "" : "hidden"
      } fixed block shadow-lg bg-white py-2 z-[99999] w-fit rounded-lg max-h-96 overflow-auto top-20 right-5 border max-w-[300px]`}
    >
      {notifications.length > 0 ? (
        notifications.map((val, ind) => (
          <li
            id={ind}
            className="dropdown-item py-2.5 px-5 flex items-center hover:bg-slate-100 text-slate-900 bg-green-50 text-sm cursor-pointer"
          >
            {val.text}
          </li>
        ))
      ) : (
        <li className="dropdown-item py-2.5 px-5 flex items-cente text-slate-400 text-sm fill-black">
          No notifications yet
        </li>
      )}
      <div className="w-full border border-gray-200 border-dashed"></div>
      <li className="dropdown-item py-2.5 px-5 flex items-center hover:bg-green-200 text-slate-900 text-sm cursor-pointer hover:fill-green-400 fill-black">
        Show all notifications
      </li>
    </ul>,
    document.getElementById("portal"),
  );
};

export default ModalClickNotification;
